// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import date from '/util/date.js';
import {Button} from '../../button';
import {Button as Rg_button} from '../button/button';
import {Checkbox} from '../../../hola/pub/lib/checkbox';
import {Link} from '../../../hola/pub/ui/link';
import Icon_cookie from '../../img/icons/32/cookie_fill.svg';
import Icon_close from '../../img/icons/12/close.svg';
// @ts-ignore
import cookie from 'cookie';
import {after_apply_cookie, perr} from 'hola_pub_util';
import etask from 'zetask';
import hola_opt from 'hola_opt';
import experiment_init from '../../../hola/pub/experiment_init';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_screen} from '../../../hola/pub/lib/screen_util';

import styles from './cookie_consent.module.less';

interface i_consent_props {
    on_apply: ()=>void;
    cookie_name?: string;
    is_toolip?: boolean;
    is_oculus?: boolean;
    is_browserai?: boolean;
    is_rewardgum?: boolean;
    is_brightsdk?: boolean;
    site?: string
    init_full?: boolean;
    is_opt_in?: boolean;
    on_close?: ()=>void;
}

interface i_clarity_consent {
   ad_storage: 'granted' | 'denied',
   analytics_storage: 'granted' | 'denied';
}

interface i_lp_consent_props extends i_consent_props {
    is_full: boolean;
    set_is_full: (v: boolean) => void;
    is_pers: boolean;
    set_is_pers: (v: boolean) => void;
    is_perf: boolean;
    set_is_perf: (v: boolean) => void;
    is_mark: boolean;
    set_is_mark: (v: boolean) => void;
    gtag: (params: object) => void;
    clarity_consent: (data: i_clarity_consent) => void;
    set_cookie: (opts: {pers: boolean, perf: boolean,
        mark: boolean}, id: string) => void;
    on_close: () => void;
}

const Cookie_consent_small = (props: i_lp_consent_props)=>{
  const {is_full, set_is_full, is_pers, set_is_pers, is_perf, set_is_perf,
      is_mark, set_is_mark, gtag,
      clarity_consent, set_cookie, on_close} = props;
  const {theme} = useContext(Settings_context);
  const is_rg = props.is_rewardgum;

  const rg_consent = (pers: boolean, perf: boolean, mark: boolean,
      id: string)=>
  {
      set_cookie({perf, pers, mark}, id);
      const ad = mark ? 'granted' : 'denied';
      const analytics = perf ? 'granted' : 'denied';
      gtag({ad_storage: ad, ad_user_data: ad,
          ad_personalization: pers ? 'granted' : 'denied',
          analytics_storage: analytics});
      clarity_consent({ad_storage: ad, analytics_storage: analytics});
  };

  const on_accept_all = ()=>{
      set_cookie({perf: true, pers: true, mark: true},
          'www_cookie_consent_click_all');
      gtag({
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
      });
      clarity_consent({ad_storage: 'granted',
          analytics_storage: 'granted'});
  };

  const on_analytics_only = ()=>{
      if (is_rg)
      {
          return void rg_consent(false, true, false,
              'www_cookie_consent_click_analytics');
      }
      set_cookie({perf: false, pers: false, mark: true},
          'www_cookie_consent_click_analytics');
      gtag({analytics_storage: 'granted'});
      clarity_consent({ad_storage: 'denied', analytics_storage: 'granted'});
  };

  const on_save_settings = ()=>{
      if (is_rg)
      {
          return void rg_consent(is_pers, is_perf, is_mark,
              'www_cookie_consent_click_save');
      }
      set_cookie({perf: is_perf, pers: is_pers, mark: is_mark},
        'www_cookie_consent_click_save');
      const consent_params = {};
      if (is_pers)
          consent_params['ad_personalization'] = 'granted';
      if (is_mark)
      {
        consent_params['ad_storage'] = 'granted';
        consent_params['ad_user_data'] = 'granted';
        consent_params['analytics_storage'] = 'granted';
      }
      if (Object.keys(consent_params).length)
          gtag(consent_params);
      const ad = is_mark ? 'granted' : 'denied';
      const analytics = is_perf || is_pers || is_mark ? 'granted' : 'denied';
      clarity_consent({ad_storage: ad, analytics_storage: analytics});
  };

  const on_analytics_only_full = ()=>{
      if (is_rg)
          return void on_analytics_only();
      set_cookie({perf: false, pers: false, mark: true},
          'www_cookie_consent_click_analytics');
      gtag({analytics_storage: 'granted'});
      clarity_consent({ad_storage: 'denied', analytics_storage: 'granted'});
  };

  const on_accept_all_full = ()=>{
      set_cookie({perf: true, pers: true, mark: true},
        'www_cookie_consent_click_all');
      gtag({
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
      clarity_consent({ad_storage: 'granted', analytics_storage: 'granted'});
  };

  const Cta = (cta_props: {caption: string, primary?: boolean,
      on_click: ()=>void})=>{
      const {caption, primary, on_click} = cta_props;
      if (props.is_rewardgum)
      {
          return <Rg_button caption={caption} size="sm"
            color={primary ? 'primary' : 'secondary'} on_click={on_click}
            cls={styles.rg_cta_button}/>;
      }
      if (props.is_brightsdk)
      {
          return <Button caption={caption} size="md" color="white"
            on_click={on_click} no_jump
            cls={cn(styles.bsdk_btn, primary && styles.bsdk_btn_primary)}/>;
      }
      return <Button caption={caption} size="xs"
        color={primary ? 'black2023' : 'white'} on_click={on_click} no_jump/>;
  };

  const InitView = ()=>{
    const box = <div className={cn(styles.content_of_consent_lp,
      props.is_rewardgum && styles.content_rg,
      props.is_brightsdk && styles.content_bsdk)}>
      <div className={styles.relative_lp}>
        <Icon_close className={styles.close_icon_lp} onClick={on_close}/>
        {props.is_brightsdk && <div className={styles.bsdk_icon}>
          <Icon_cookie/>
        </div>}
        <div className={styles.text_lp}>
          <p className={cn([theme.p3, theme.med, styles.title,
            !props.is_rewardgum && theme.color_n700])}>
            We value your privacy
          </p>
          <p className={cn([theme.p4, theme.reg])}>
            We recommend you accept all cookies for the optimal experience
            when using our website.
          </p>
        </div>
        <div className={styles.buttons}>
          <Cta caption="Cookies settings" on_click={()=>set_is_full(true)}/>
          <Cta caption="Analytics only" primary={props.is_brightsdk}
            on_click={on_analytics_only}/>
          <Cta caption="Accept all" primary on_click={on_accept_all}/>
        </div>
      </div>
    </div>;
    return props.is_brightsdk
      ? <div className={styles.bsdk_backdrop}>{box}</div> : box;
  };

  const FullView = ()=><div className={cn(styles.overlay_lp,
    styles.with_blur_lp, props.is_rewardgum && styles.overlay_rg,
    props.is_brightsdk && styles.overlay_bsdk)}>
      <div className={cn(styles.relative_lp, styles.relative_lp_full)}>
        <Icon_close className={cn(styles.close_icon_lp,
          styles.relative_lp_full)} onClick={on_close}/>
        <div className={cn(styles.content_of_consent_lp, styles.full_view_lp,
          props.is_rewardgum && styles.full_view_rg,
          props.is_brightsdk && styles.full_view_bsdk)}>
          <div className={styles.full_data_lp}>
            <div className={styles.text_lp}>
              <p className={cn(theme.p3, theme.med, styles.title,
                styles.accent)}>
                {props.site} uses cookies to optimize your experience
              </p>
              <p className={cn(theme.p4, theme.reg, styles.m24)}>
                We use cookies because they are necessary for our website
                to function. We use other cookies to enhance your experience by
                providing insights on how you use our website. We recommend
                accepting all cookies to get the most value when using our
                website. You can learn more about each category of cookies
                by reading our <Link href="legal/privacy-policy">
                Privacy Policy</Link>
              </p>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Necessary cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Necessary cookies
                  provide core functionality and are essential for the website
                  to perform properly. They are enabled by default and cannot
                  be disabled.</p>
              </div>
              <Checkbox checked={true} on_change={()=>perr(
                {id: 'www_cookie_consent_try_turnoff_n'})}
                mode="toggle" disabled/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Personalization cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Personalization cookies
                  help us customize the content you see on this website based
                  on your usage.</p>
              </div>
              <Checkbox checked={is_pers} on_change={set_is_pers}
                mode="toggle"/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Performance cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies allow us
                  to monitor and improve website performance.</p>
              </div>
              <Checkbox checked={is_perf} on_change={set_is_perf}
                mode="toggle"/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Marketing cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies increase
                  the value of the campaigns and offers you receive by
                  tailoring them to your specific needs.</p>
              </div>
              <Checkbox checked={is_mark} on_change={set_is_mark}
                mode="toggle"/>
            </div>
            <div className={styles.buttons_lp}>
              <Cta caption="Save settings" on_click={on_save_settings}/>
              <Cta caption="Analytics only" primary={props.is_brightsdk}
                on_click={on_analytics_only_full}/>
              <Cta caption="Accept all" primary
                on_click={on_accept_all_full}/>
            </div>
          </div>
        </div>
      </div>
    </div>;

  return is_full ? <FullView/> : <InitView/>;
};

export const Cookie_consent = (props: i_consent_props)=>{
    const {theme, theme_name} = useContext(Settings_context);
    const cookie_name = props.cookie_name || 'allow_hola_cookie';
    const version = props.is_rewardgum
        && hola_opt?.www_hola?.cookie_consent?.version;
    const saved: any = (()=>{
        try {
            const value = JSON.parse(cookie.get(cookie_name) || '{}');
            if (version && value.v!=version)
                return hola_opt?.cookie_value_parsed || {};
            return value;
        } catch { return hola_opt?.cookie_value_parsed || {}; }
    })();
    const def_on = !props.is_rewardgum;
    const [is_full, set_is_full] = useState(!!props.init_full);
    const rg_info = {
        source: 'www',
        opt_in: !!props.is_opt_in,
        view: is_full ? 'settings' : 'banner',
    };
    const site_perr = (id: string)=>perr(props.is_rewardgum
        ? {id, info: rg_info} : {id});
    const [is_pers, set_is_pers] = useState(saved.pers ?? def_on);
    const [is_perf, set_is_perf] = useState(saved.perf ?? def_on);
    const [is_mark, set_is_mark] = useState(saved.mark ?? def_on);
    const [is_client, set_is_client] = useState(false);
    const [is_consent_closed, set_is_consent_closed] = useState(false);
    const site = props.is_oculus ? 'Oculus' :
        props.is_toolip ? 'Toolip' :
        props.is_browserai ? 'BrowserAI' :
        props.is_rewardgum ? 'RewardGum' :
        props.is_brightsdk ? 'Bright SDK' :
        'Hola';
    useEffect(()=>{
        set_is_client(true);
        site_perr('www_cookie_consent_show');
    }, []);
    useEffect(()=>{
        if (!is_full || !props.is_rewardgum || props.init_full)
            return;
        perr({
            id: 'www_cookie_consent_open_full',
            info: {...rg_info, view: 'banner'},
        });
    }, [is_full]);
    const set_cookie = ({pers, perf, mark}, id)=>etask(function*(){
        const obj = {
            n: true,
            pers, perf, mark,
            ...version ? {v: version} : {},
        };
        try {
            cookie.set(props.cookie_name || 'allow_hola_cookie',
              JSON.stringify(obj),
              {domain: `.${window.location.host}`,
                path: '/', expires: date.add(date(), {year: 10})});
            yield perr(props.is_rewardgum ? {
                id,
                info: {...rg_info, pers, perf, mark},
                build: {gdpr_agreed: String(!!mark)},
            } : {id});
            Object.assign(hola_opt.cookie_value_parsed, obj);
            if (hola_opt.temp_cookie)
            {
                hola_opt.temp_cookie.forEach(cookie_line=>{
                    if (obj[cookie_line[3]])
                    {
                        cookie.set(cookie_line[0], cookie_line[1],
                            cookie_line[2]);
                    }
                });
            }
            if (pers || perf || mark)
            {
                experiment_init.move_it_to_cookie(
                    {host: window.location.host});
            }
            // for setting xsrf token
            yield fetch('/ping');
            // @ts-ignore
            if (window.for_eval_when_cookie_ready
                && (mark || props.is_rewardgum && perf))
            {
                // @ts-ignore
                window.for_eval_when_cookie_ready.forEach(code=>{
                    eval(code);
                });
            }
            after_apply_cookie();
            // @ts-ignore
            if (window.global_etask_for_wait_cookie)
            {
                // @ts-ignore
                window.global_etask_for_wait_cookie.forEach(resolve=>{
                    resolve();
                });
            }
            window.dispatchEvent(new CustomEvent('session_changed'));
        } catch {}
        props.on_apply();
    });
    const {width, height} = use_screen();
    const [fc_h, set_fc_h] = useState(205);
    useEffect(()=>{
        const fc_el = document.getElementById('content_of_consent');
        if (fc_el)
        {
            setTimeout(()=>{
                set_fc_h(fc_el.offsetHeight);
            }, 0);
            set_fc_h(fc_el.offsetHeight);
        }
    }, [width, is_full, fc_h, height, is_client]);
    if (!is_client)
        return <Fragment></Fragment>;
    const gtag = (params: object)=>(window as any)?.gtag?.('consent',
        props.is_rewardgum ? 'update' : 'default', params);
    const clarity_consent = (data: i_clarity_consent)=>{
        if (typeof window !== 'undefined' && window.clarity)
        {
            window.clarity('consentv2', {
                ad_Storage: data.ad_storage,
                analytics_Storage: data.analytics_storage,
            });
        }
    };
    const on_consent_close = ()=>{
        set_is_consent_closed(true);
        props.on_close?.();
        site_perr('www_cookie_consent_small_close');
    };
    if (!is_client || is_consent_closed)
        return <Fragment></Fragment>;
    const is_page_with_small_cookie = props.is_rewardgum
      || props.is_brightsdk
      || !!hola_opt?.www_hola?.small_cookie
          ?.includes(window?.location?.pathname)
      || window?.location?.host === 'hola.org';
    if (is_page_with_small_cookie)
    {
      return <Cookie_consent_small {...props}
        is_full={is_full} set_is_full={set_is_full} is_pers={is_pers}
        set_is_pers={set_is_pers} is_perf={is_perf}
        set_is_perf={set_is_perf} is_mark={is_mark}
        set_is_mark={set_is_mark} gtag={gtag}
        clarity_consent={clarity_consent} set_cookie={set_cookie}
        on_close={on_consent_close}
        site={site}
      />;
    }
    return <div className={cn(styles.overlay, styles.with_blur, theme.root)}>
      <div id={'fixed_container'}
        style={{
          '--fc_h': `${fc_h}px`,
          '--fc_h2': `${Math.round(fc_h/2)}px`,
        } as any}
        className={cn(styles.fixed_container, is_full && styles.center)}>
        <div id={'content_of_consent'}
          className={cn(styles.content_of_consent, is_full ?
          styles.full : styles.small)}>
          <div className={cn(styles.short, is_full && styles.hidden)}>
            <div className={styles.cookie_icon_wrapper}>
              <Icon_cookie className={styles.cookie_icon}/>
            </div>
            <p className={cn(
              theme_name=='toolip' || theme_name=='oculus' ? theme.p20 :
              theme.p4,
              theme.med,
              styles.short_title
            )}>
              We value your privacy
            </p>
            <p
              className={cn(
                theme_name=='toolip' || theme_name=='oculus'
                  ? theme.p16
                  : theme.p4,
                theme.reg,
                styles.short_text
              )}
            >
              We recommend you accept all cookies for the optimal experience
              when using our website.
            </p>
          </div>
          <div className={cn(styles.full_data, !is_full && styles.hidden)}>
            <p className={cn(theme.p3, theme.med, styles.title,
              styles.accent)}>
                {site} uses cookies to optimize your experience</p>
            <p className={cn(theme.p4, theme.reg, styles.m24)}>We use cookies
              because they
              are necessary for our website to function. We use other cookies
              to enhance your experience by providing insights on how you use
              our website. We recommend accepting all cookies to get the most
              value when using our website. You can learn more about each
              category of cookies by reading our Privacy Policy</p>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Necessary cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Necessary cookies
                  provide core functionality and are essential for the
                  website to perform properly. They are enabled by default
                  and cannot be disabled.</p>
              </div>
              <Checkbox checked={true} on_change={()=>{
                perr({id: 'www_cookie_consent_try_turnoff_n'});
              }} mode={'toggle'} disabled/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Personalization cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Personalization cookies
                  help us customize the content you see on this website based
                  on your usage.</p>
              </div>
              <Checkbox checked={is_pers} on_change={set_is_pers}
                mode={'toggle'}/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Performance cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies allow us
                  to monitor and improve website performance.</p>
              </div>
              <Checkbox checked={is_perf} on_change={set_is_perf}
                mode={'toggle'}/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Marketing cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies increase
                the value of the campaigns and offers you receive by
                tailoring them to your specific needs.</p>
              </div>
              <Checkbox checked={is_mark} on_change={set_is_mark}
                mode={'toggle'}/>
            </div>
          </div>
          <div className={styles.buttons}>
            <Button caption={is_full ? 'Save settings' : 'Cookies settings'}
              color={'white'}
              size='xs'
              on_click={()=>{
                if (is_full)
                {
                  set_cookie({perf: is_perf, pers: is_pers,
                    mark: is_mark}, 'www_cookie_consent_click_save');
                  const consent_params = {};
                  if (is_pers)
                    consent_params['ad_personalization'] = 'granted';
                  if (is_mark)
                  {
                    consent_params['ad_storage'] = 'granted';
                    consent_params['ad_user_data'] = 'granted';
                    consent_params['analytics_storage'] = 'granted';
                  }
                  if (Object.keys(consent_params).length)
                    gtag(consent_params);
                  const ad = is_mark ? 'granted' : 'denied';
                  const analytics =
                    is_perf || is_pers || is_mark ? 'granted' : 'denied';
                  clarity_consent({
                    ad_storage: ad,
                    analytics_storage: analytics
                  });
                }
                else
                {
                  perr({id: 'www_cookie_consent_open_full'});
                  set_is_full(true);
                }
              }} no_jump/>
            <Button caption={'Analytics only'} color={'white'}
              size='xs' on_click={()=>{
                set_cookie({perf: false, pers: false, mark: true},
                  'www_cookie_consent_click_analytics');
                gtag({analytics_storage: 'granted'});
                clarity_consent({
                  ad_storage: 'denied',
                  analytics_storage: 'granted'
                });
              }} no_jump/>
            <Button caption={'Accept all'}
              color={theme_name=='hola2023' ? 'black2023' : 'black'}
              size='xs'
              on_click={()=>{
                set_cookie({perf: true, pers: true, mark: true},
                  'www_cookie_consent_click_all');
                gtag({
                  ad_storage: 'granted',
                  ad_user_data: 'granted',
                  ad_personalization: 'granted',
                  analytics_storage: 'granted',
                });
                clarity_consent({
                  ad_storage: 'granted',
                  analytics_storage: 'granted'
                });
              }} no_jump/>
          </div>
        </div>
      </div>
    </div>;
};
